import React from "react";
import { Badge, type BadgeVariant } from "@purpur/badge";
import c from "classnames/bind";

import styles from "./card-badge.module.scss";

const cx = c.bind(styles);

export type CardBadgeProps = {
  /**
   * Use this to set a testid on the badge
   */
  ["data-testid"]?: string;
  /**
   * The variant (color) of the badge in the top right corner of the card. This is coupled with the text prop. Both needs to be set for the badge to be displayed.
   * `BadgeVariant = "attention" | "special" | "neutral" | "information" | "success" | "warning" | "error"`
   */
  variant?: BadgeVariant;
  /**
   * The text that will be in the badge in the top right corner of the card. This is coupled with the variant prop. Both needs to be set for the badge to be displayed.
   */
  text?: string;
};

const rootClassName = "purpur-card-badge";

export const CardBadge = ({
  ["data-testid"]: dataTestId = "purpur-card-badge",
  variant,
  text,
}: CardBadgeProps) => {
  return variant && text ? (
    <Badge
      className={cx(rootClassName)}
      variant={variant}
      showIcon={false}
      data-testid={dataTestId}
    >
      {text}
    </Badge>
  ) : null;
};
